import { useSeoMeta } from "@unhead/react";
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Ghost } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useSeoMeta({
    title: "404 — Page Not Found · TrustWeb",
    description: "The page you are looking for could not be found. Return to TrustWeb to analyze a Nostr identity.",
  });

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center px-4">
        <Ghost className="mx-auto size-12 text-primary/60 mb-6" />
        <h1 className="font-display text-5xl font-bold mb-3">404</h1>
        <p className="text-lg text-muted-foreground mb-6">
          This identity is off the web — page not found.
        </p>
        <Button asChild>
          <Link to="/">Return to TrustWeb</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
